// Import from the renamed file to avoid case sensitivity issues
import ChangeSkill from './change-skill-component';

// Export the component as default
export default ChangeSkill;
